import { useState, useEffect } from 'react';

interface GeoLocation {
  countryCode: string;
  loading: boolean;
  error: string | null;
}

export const useGeoLocation = () => {
  const [state, setState] = useState<GeoLocation>({
    countryCode: 'US', // Default to US
    loading: true,
    error: null
  });

  useEffect(() => {
    const detectLocation = async () => {
      try {
        // Use a free IP geolocation service
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        if (data.country_code) {
          setState({
            countryCode: data.country_code,
            loading: false,
            error: null
          });
        } else {
          throw new Error('Could not detect country');
        }
      } catch (error) {
        console.error('Error detecting location:', error);
        setState(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to detect location'
        }));
      }
    };

    detectLocation();
  }, []);

  return state;
};